import { render, staticRenderFns } from "./salesStat_h.vue?vue&type=template&id=ddc4f4ec&"
import script from "./salesStat_h.vue?vue&type=script&lang=js&"
export * from "./salesStat_h.vue?vue&type=script&lang=js&"
import style0 from "./salesStat_h.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "salesStat_h.vue"
export default component.exports